import React from 'react'
import Layout from '../../Layout'
import { Link } from 'react-router-dom'
import Information from './Components/Information'
import Tab from './Components/Tab'
import { useNavigate } from 'react-router-dom'

function Index() {
    const navigate = useNavigate();
    return (
        <Layout>
            <div className='myproducts-top'>
                <div className='d-flex profile-header'>
                    <div className="right d-flex">
                        <a href="#" onClick={() => { navigate(-1) }}><i className="fas fa-arrow-right"></i></a>
                        <span>پروفایل کاربر</span>
                    </div>
                    <Link to={"/Settings"}>
                        <i class="fas fa-cog"></i>
                    </Link>
                </div>
                <Information />
            </div>
            <div className="myproducts-bottom">
                <Tab />
            </div>
            
        </Layout>
    )
}
export default Index